import React from 'react';
import { FieldConfig } from '../../../playground/common/field-types';
import { renderRateScheduleField } from '../../../playground/endpoints/_shared';
import { ContributionListField } from '../_shared';
import { BeneficiaryListField } from './beneficiary-list-field';
import {
  COMPENSATION_PLAN_OPTIONS,
  GENDER_OPTIONS,
  PAYMENT_PERIODICITY_OPTIONS,
  RATE_MODE_OPTIONS,
  SAVINGS_MODE_OPTIONS,
  UniversitySavingsV2FormValues,
} from './schema';

const CLIENTE = 'Datos del cliente';
const POLIZA = 'Detalle de la póliza';
const CAPITALES = 'Capitales';
const BENEFICIARIOS = 'Beneficiarios';
const MODO = 'Modo y campos específicos';
const APORTES = 'Aportes y primas';

const isCapacityMode = (v: UniversitySavingsV2FormValues) => v.savings_mode === 'savings_capacity';
const isFixedRate = (v: UniversitySavingsV2FormValues) => v.rate_mode === 'fixed';
const isSteppedRate = (v: UniversitySavingsV2FormValues) => v.rate_mode === 'stepped';

// eslint-disable-next-line max-len
export const UNIVERSITY_SAVINGS_V2_FIELDS: readonly FieldConfig<UniversitySavingsV2FormValues>[] = [
  {
    key: 'date_of_birth', label: 'Fecha de nacimiento', kind: 'date', section: CLIENTE,
  },
  {
    key: 'gender', label: 'Género', kind: 'select', options: GENDER_OPTIONS, section: CLIENTE,
  },
  {
    key: 'compensation_plan',
    label: 'Plan de compensación',
    kind: 'select',
    options: COMPENSATION_PLAN_OPTIONS,
    section: POLIZA,
  },
  {
    key: 'death_insured_capital',
    label: 'Capital muerte (UF)',
    kind: 'number',
    colClassName: 'col-md-6',
    section: CAPITALES,
  },
  {
    key: 'accidental_death_insured_capital',
    label: 'Capital muerte accidental (UF)',
    kind: 'number',
    colClassName: 'col-md-6',
    section: CAPITALES,
  },
  {
    key: 'itp_insured_capital',
    label: 'Capital ITP 2/3 (UF)',
    kind: 'number',
    colClassName: 'col-md-6',
    section: CAPITALES,
  },
  {
    key: 'serious_illness_insured_capital',
    label: 'Capital enfermedades graves (UF)',
    kind: 'number',
    colClassName: 'col-md-6',
    section: CAPITALES,
  },
  {
    key: 'beneficiaries',
    label: 'Datos de beneficiarios',
    kind: 'custom',
    render: (form) => <BeneficiaryListField form={form} name="beneficiaries" />,
    section: BENEFICIARIOS,
  },
  {
    key: 'savings_mode',
    label: 'Modo de proyección',
    kind: 'select',
    options: SAVINGS_MODE_OPTIONS,
    section: MODO,
  },
  {
    key: 'rate_mode',
    label: 'Modo de tasa',
    kind: 'select',
    options: RATE_MODE_OPTIONS,
    section: MODO,
  },
  {
    key: 'projection_rate',
    label: 'Tasa de proyección anual',
    kind: 'number',
    step: 0.0001,
    visibleWhen: isFixedRate,
    section: MODO,
  },
  {
    key: 'projection_rate_schedule',
    label: 'Tramos de tasa',
    kind: 'custom',
    visibleWhen: isSteppedRate,
    render: renderRateScheduleField,
    section: MODO,
  },
  {
    key: 'agreed_premium',
    label: 'Prima acordada (UF por período)',
    kind: 'number',
    visibleWhen: isCapacityMode,
    section: APORTES,
  },
  {
    key: 'payment_periodicity',
    label: 'Periodicidad de pago',
    kind: 'select',
    options: PAYMENT_PERIODICITY_OPTIONS,
    section: APORTES,
  },
  {
    key: 'contributions',
    label: 'Aportes',
    kind: 'custom',
    render: (form) => (
      <ContributionListField
        form={form}
        name="contributions"
        addLabel="+ Agregar aporte"
        emptyLabel="Sin aportes."
      />
    ),
    section: APORTES,
  },
];
